import lazyWithReducer from 'app/store/lazyWithReducer';
import authRoles from '../../auth/authRoles';
import SendEmailApp from './SendEmailApp';

const SendEmailAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.admin,
	routes: [
		{
			path: 'admin-send-email',
			element: <SendEmailApp />,
			exact: true
		}
	]
};

export default SendEmailAppConfig;
